module.exports = {
    "names": [
        'Urbanization in the Suburbs of Seattle'
    ]
}